module.exports = __webpack_public_path__ + "img/refle-left.eac54741.png";